export default {
    blackmask:false,
    BgStyle: false,
    routerID:'',
    dropDom:'',        //拖拽dom
    userID:'',
    userAvatar:'',
    userName:'',
}